var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, registerPixiComponent } from "../ComponentRegistry.js";
import { BV2 } from "../../utils/vector.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import "../types.js";
import * as PIXI from "pixi.js";
import { L as LocomotionSchema } from "../../Locomotion-379972de.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
class BitecsLocomotionSystem {
  constructor(gameModel) {
    __publicField(this, "type", "Locomotion");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", LocomotionSchema);
    __publicField(this, "depth", 1);
    __publicField(this, "query");
    this.query = gameModel.defineQuery([TransformSchema, LocomotionSchema]);
  }
  runAll(gameModel) {
    const entities = this.query(gameModel.world);
    for (let i = 0; i < entities.length; i++) {
      const entityId = entities[i];
      const locomotionSchema = gameModel.getTypedUnsafe(entityId, LocomotionSchema);
      const transformSchema = gameModel.getTypedUnsafe(entityId, TransformSchema);
      if ((locomotionSchema.decayingVelocityX || locomotionSchema.decayingVelocityY) && locomotionSchema.decayingVelocityTime === 0) {
        locomotionSchema.decayingVelocityTime = 150;
      }
      if (!locomotionSchema.fixedDirection && (Math.round(locomotionSchema.velocityX) !== 0 || Math.round(locomotionSchema.velocityY) !== 0)) {
        const direction = BV2.normalizeVector2d(locomotionSchema.velocityX, locomotionSchema.velocityY);
        locomotionSchema.directionX = direction[0];
        locomotionSchema.directionY = direction[1];
      }
      transformSchema.previousX = transformSchema.x;
      transformSchema.previousY = transformSchema.y;
      transformSchema.previousZ = transformSchema.z;
    }
  }
}
registerSystem(BitecsLocomotionSystem);
class DebugLocomotionDraw {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "entities", {});
    __publicField(this, "debug", true);
  }
  init(entity, gameModel, viewport) {
    const container = new PIXI.Container();
    container.zIndex = 1e5;
    const directionGraphic = new PIXI.Graphics();
    container.addChild(directionGraphic);
    const entityObj = {
      container,
      directionGraphic
    };
    viewport.addChild(container);
    this.entities[entity] = entityObj;
    this.ids.add(entity);
  }
  run(entity, gameModel) {
    const transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
    const locomotionSchema = gameModel.getTypedUnsafe(entity, LocomotionSchema);
    const entityPosition = transformSchema.position;
    const container = this.entities[entity].container;
    container.position.set(entityPosition.x, entityPosition.y);
    const directionGraphic = this.entities[entity].directionGraphic;
    directionGraphic.clear();
    directionGraphic.lineStyle(5, 16711680);
    directionGraphic.moveTo(0, 0);
    directionGraphic.lineTo(locomotionSchema.directionX * 30, locomotionSchema.directionY * 30);
  }
  cleanup(entity) {
    if (!this.entities[entity]) {
      return;
    }
    const container = this.entities[entity].container;
    container.children.forEach((child) => {
      container.removeChild(child);
      child.destroy();
    });
    container.destroy();
    delete this.entities[entity];
    this.ids.delete(entity);
  }
}
registerPixiComponent("Locomotion", DebugLocomotionDraw);
//# sourceMappingURL=Locomotion.js.map
